<template>

<div>
    
    <div class="comment-section">

        <div>
            <div class="d-flex justify-content-between mb-4">
                <button id="add-answer" class="btn btn-outline-secondary collapsed" type="button" data-toggle="collapse" data-target="#new-message" aria-expanded="false" aria-controls="new-message">
                    <span class="icon icon-plus-circle"></span>
                    Ново съобщение
                </button>

                <div @click='$parent.setPage("messages")' v-if='$parent.model' >
                    <user-disabled-notifs :pid='$parent.model.id'></user-disabled-notifs>
                </div>
            </div>

            <div id="new-message" class="collapse card card-comment mb-4">
                <div class="your-answer answer border-0 mt-0">
                    <div class="d-flex align-items-center justify-content-center justify-content-md-start card-header">
                        <span class="answer-num mr-2 mb-2">#</span>
                        <h6 class="answer-title">Съобщение:</h6>
                    </div>

                    <div class="card-body ml-2 pl-4 mr-2 pr-4 mb-4 pb-1">
                        <textarea class="form-control mb-3" rows="5" v-model='newMsg.message'></textarea>

                        <div class="d-flex justify-content-center justify-content-md-start">
                            <button @click='publish( newMsg )' class="btn btn-primary mr-2">
                                <span class="icon icon-save"></span>
                                Публикувай
                            </button>
                            <button class="btn btn-outline-dark" type="button" data-toggle="collapse" data-target="#new-message" aria-expanded="false" aria-controls="new-message">
                                Отказ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for='(m,i) in messages' class="card card-comment mb-4" :id='"cc-" + m.id'>
            <div class="card-header d-flex justify-content-between align-items-center flex-wrap row">
                <div class="col-md-6">
                    <div class="card-header-left d-flex align-items-center justify-content-center justify-content-md-start">
                        <span class="comment-num mr-2 mb-2">#{{ i+1 }}</span>
                        <h5 class="card-title">
                        
                            <span v-if='typeof m.admin_id == "number"'>  Администратор : </span>
                            <span v-if='!m.admin_id && m.user_id != config.owner_id'> 
                                {{ m.brand ? m.brand : m.name }} : 
                            </span>
                            <span v-if='!m.admin_id && m.user_id == config.owner_id'> Собственик на проекта : </span>

                        </h5>
                    </div>
                </div>

                <div class="col-md-6 text-center text-md-right">
                    <div class="card-header-right">
                        <span class="comment-time ml-3">
                            <span class="icon icon-clock"></span>
                            {{ timeOnly( m.created_at ) }}
                        </span>

                        <span class="comment-date ml-3">
                            <span class="icon icon-calendar"></span>
                             {{ dateOnly( m.created_at ) }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="card-body">

                {{ m.message }}

                <div v-if='replies[ m.id ].length' v-for='(r,i) in replies[ m.id ]' class="answer mt-4">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row">
                        
                        <div class="col-md-6">
                            <div class="card-header-left d-flex align-items-center justify-content-center justify-content-md-start">
                                <span class="answer-num mr-2 mb-2">#</span>
                                <h6 class="answer-title">

                                    <span v-if='typeof r.admin_id == "number"'>  Администратор : </span>
                                    <span v-if='!r.admin_id && r.user_id != config.owner_id'> {{ r.name }} : </span>
                                    <span v-if='!r.admin_id && r.user_id == config.owner_id'> Собственик на проекта : </span>
                               
                                </h6>
                            </div>
                        </div>

                        <div class="col-md-6 text-center text-md-right">
                            <div class="card-header-right">
                                <div class="card-header-right">
                                    <span class="comment-time ml-3">
                                        <span class="icon icon-clock"></span>
                                        {{ timeOnly( r.created_at ) }}
                                    </span>

                                    <span class="comment-date ml-3">
                                        <span class="icon icon-calendar"></span>
                                         {{ dateOnly( r.created_at ) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="answer-content">
                        {{ r.message }}
                    </div>
                </div>

            </div>

            <div class="card-footer">              
                <div :id="'answer-' + m.id" class="your-answer answer collapse">
                    <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                        <span class="answer-num mr-2 mb-2">#</span>
                        <h6 class="answer-title">Вашият отговор:</h6>
                    </div>

                    <textarea class="form-control mb-3" rows="5" 
                              v-model='replyMdl[ m.id ].message'></textarea>

                    <div class="d-flex justify-content-center justify-content-md-start">
                        <button @click='publish( replyMdl[ m.id ], m.id )' class="btn btn-primary mr-2">
                            <span class="icon icon-save"></span>
                            Публикувай
                        </button>
                         <button class="btn btn-outline-dark" type="button" data-toggle="collapse" 
                                :data-target="'#answer-' + m.id" aria-expanded="false" 
                                :aria-controls="'answer-' + m.id">
                            Отказ
                        </button>
                    </div>
                </div>

                <div class="d-flex justify-content-center justify-content-md-start">
                    <button id="add-answer" 
                            class="btn btn-outline-secondary collapsed" 
                            type="button" 
                            data-toggle="collapse" 
                            :data-target="'#answer-' + m.id" aria-expanded="false" 
                            :aria-controls="'answer-' + m.id">                   
                        <span class="icon icon-corner-down-right"></span>
                        Отговор                 
                    </button>
                </div>
            </div>
        </div>

        <div v-if='!messages.length'>

            <div class="alert alert-info">
                Все още няма съобщения
            </div>

        </div>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();

            bus.$emit("set-title", "Въпроси и отговори");
        },

        created() {
            if( typeof this.conf == 'object' ) {
                this.config = Object.assign({}, this.config, this.conf);
            }
        },

        //Project ID
        props : ['pid','conf'],

        data() {
            return {

                isReady  : false,
                messages : [],
                replies  : false,

                config : {

                    getParams : {
                        id : this.$parent.p
                    },

                    publishParams : {
                        project_id : this.$parent.p
                    },

                    publishUrl  : 'pmsg:publ',
                    getUrl      : 'pmsg:gt',
                    owner_id    : null

                },

                newMsg : {
                    parent   : null,
                    message  : '',
                },

                replyMdl : {}

            }
        },

        methods : {

            publish( msg, MID ) {
                var me = this;

                if( !msg.message ) {
                    $.notify('Моля въведете съобщение','warninig');
                    return false;
                }

                msg = Object.assign( {}, msg, me.config.publishParams );

                me.ajax.call( this.config.publishUrl, msg, (r) => {
                    
                    if( r.status == 'success' ) {

                        r.data.admin_id = null;
                        r.data.name = me.user.name;

                        if( typeof me.replies[ msg.parent ] != 'object' ) {
                            me.replies[ msg.parent ] = [];
                        }

                        me.replyMdl[ r.data.id ] = {

                            parent      : r.data.id,
                            // project_id  : this.$parent.p,
                            message     : ''
                        
                        }

                        if( typeof MID != 'undefined') {
                            $('button[data-target="#answer-'+ MID + '"]').click();
                        }

                        me.replyMdl = Object.assign( {}, me.replyMdl );

                        if( msg.parent ) {

                            me.replies[ msg.parent ].push( r.data );
                            me.replies = Object.assign({}, me.replies);

                        } else {

                            $("#new-message").collapse("toggle");

                            setTimeout( () => {
                                me.navigate( "#cc-" + r.data.id, 350 );
                            },400);

                            me.messages.push( r.data );

                        }

                        msg.message = '';

                        me.$parent.messages += 1;

                        $.notify('Съобщението ви беше публиувано успешно', 'success');

                    }

                })

            },

            getData() {
                var me = this;

                me.ajax.call( this.config.getUrl, this.config.getParams , (r) => {

                    if( r.status == 'success' ) {

                        me.buildMessages( r.data );

                    }

                    me.isReady = true;

                })
            },

            buildMessages( messages ) {
                var replies = {};

                for( var i in messages ) {

                    this.replyMdl[ messages[i].id ] = {

                        parent      : messages[i].id,
                        // project_id  : this.$parent.p,
                        message     : ''
                    
                    }

                    if( typeof replies[ messages[i].parent ] != 'object' ) {
                        replies[ messages[i].parent ] = [];
                    }

                    if( !messages[i].parent ) {

                        this.messages.push( messages[i] );

                    } else {
                    
                        replies[ messages[i].parent ].push( messages[i] );

                    }

                }

                this.replies = replies;
            }

        }

    }
</script>
<style>

</style>